module.exports = __webpack_public_path__ + "static/img/rank_283.be6cc1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_283.png
// module id = OUWB
// module chunks = 1